export default __webpack_public_path__ + "static/fabi_rodrigues-35ea4f3be3d9f3d38648f172c8a48b74.jpg";